// extracted by mini-css-extract-plugin
module.exports = {"siteFooter":"site-footer-module--siteFooter--3E_52","someIcon":"site-footer-module--someIcon--1Xjcj","copy":"site-footer-module--copy--3cksX"};